import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { fetcher } from '~lib/api/fetch';
import { Nullable } from '~types/common';

import QueryKeys from '../queryKeys';

const url = (companyId: string) => `/api/company/${companyId}/salariesChart`;

export type SalariesChartData = {
  date: string;
  salary: Nullable<number>;
};

export default function useCompanySalaryChart(companyId: string) {
  return useQuery<SalariesChartData[], AxiosError>(
    [QueryKeys.companySalaryChart, companyId],
    () => fetcher(url(companyId)),
    {
      enabled: !!companyId,
    },
  );
}
